import { INDEX_SETTLE_MS } from './listPlacements'

/**
 * Tells counts that read list membership from the search index when a list write has had time
 * to land there. Calls wait out `INDEX_SETTLE_MS` from the last write, so a bulk write is one read.
 */
const listeners = new Set<() => void>()
let settleTimer: ReturnType<typeof setTimeout> | undefined

export function announceListWrite(): void {
  clearTimeout(settleTimer)
  settleTimer = setTimeout(() => {
    settleTimer = undefined
    for (const listener of [...listeners]) listener()
  }, INDEX_SETTLE_MS)
}

export function onSettledListWrite(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
